import Footer from "./Footer";
import Header from "./Header";
import SideBookingCta from "./SideBookingCta";
import TopBar from "./TopBar";

function PageLayout({ children, ctaHref }) {
  return (
    <div className="bg-white text-slate-900 antialiased">
      <TopBar />
      <Header ctaHref={ctaHref} />
      <SideBookingCta href={ctaHref || "/booking"} />
      {children}
      <Footer />
    </div>
  );
}

export default PageLayout;
